'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Alert = require('../../Alert/src/Alert.js');
var _utils = require('../../Transition/src/_utils.js');
require('../../Transition/src/Fade.js');
require('../../Transition/src/ScaleFade.js');
require('../../Transition/src/SlideFade.js');
require('../../Transition/src/Collapse.js');
var Notifications_module = require('../styles/Notifications.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Notification component.
 *
 * @component
 * @example
 * ```jsx
 * <Notification />
 * ```
 */
const Notification = React__namespace.memo((props) => {
    const { id, type, title, subtitle, message, closable = true, onClose } = props;
    const cx = reactUtils.useStyles(Notifications_module.default);
    const alertClassNames = cx('alert', {
        [`type-${type}`]: type,
    });
    const alertMotionProps = React__namespace.useMemo(() => ({
        variants: {
            exit: {
                opacity: 0,
                x: 400,
                height: 0,
                transition: {
                    x: { duration: 0.1, ease: _utils.EASINGS.easeOut },
                    height: { delay: 0.1, duration: 0.1 },
                    duration: 0.2,
                    ease: _utils.EASINGS.easeOut,
                },
            },
            enter: {
                opacity: 1,
                height: 'auto',
                x: 0,
                transition: {
                    height: { duration: 0.1 },
                    x: { delay: 0.1, ease: _utils.EASINGS.easeInOut },
                    duration: 0.25,
                    delay: 0.2,
                    ease: _utils.EASINGS.easeInOut,
                },
            },
        },
        initial: 'exit',
        animate: 'enter',
        exit: 'exit',
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            mass: 0.2,
        },
        drag: 'x',
        draggable: true,
        dragElastic: 0.2,
        dragConstraints: { left: 0, right: 400 },
    }), []);
    const handleClickClose = React__namespace.useCallback(() => {
        onClose(id);
    }, [id, onClose]);
    const handleDragEnd = React__namespace.useCallback((_, { offset, velocity }) => {
        if (Math.abs(offset.x) * velocity.x > 0) {
            onClose(id);
        }
    }, [id, onClose]);
    const MotionComponent = framerMotion.motion(Alert.Alert);
    return (React__namespace.createElement(MotionComponent, { ...alertMotionProps, className: alertClassNames, title: title, subtitle: subtitle, closable: closable, onClose: handleClickClose, 
        // @ts-ignore
        onDragEnd: handleDragEnd }, message));
});
Notification.displayName = 'Notification';

exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map
